import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const SESSION_KEY = 'tocxi_tracking_session';
const API_BASE = process.env.REACT_APP_API_BASE_URL;

export function getSessionId() {
  try {
    let id = sessionStorage.getItem(SESSION_KEY);
    if (!id) {
      id = (crypto.randomUUID ? crypto.randomUUID() : `s_${Date.now()}_${Math.random().toString(36).slice(2)}`).slice(0, 64);
      sessionStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch { return null; }
}

function getUtm(search) {
  const p = new URLSearchParams(search);
  return {
    utmSource: p.get('utm_source') || undefined,
    utmMedium: p.get('utm_medium') || undefined,
    utmCampaign: p.get('utm_campaign') || undefined,
  };
}

const VisitTracker = () => {
  const { pathname, search } = useLocation();
  const lastPath = useRef(null);

  useEffect(() => {
    if (lastPath.current === pathname) return;
    lastPath.current = pathname;

    const sessionId = getSessionId();
    const utm = getUtm(search);
    const referrer = document.referrer || null;

    // Fire-and-forget. Use sendBeacon if available for reliability on nav.
    const payload = JSON.stringify({
      sessionId, path: pathname, referrer,
      utmSource: utm.utmSource, utmMedium: utm.utmMedium, utmCampaign: utm.utmCampaign,
    });

    try {
      if (navigator.sendBeacon) {
        const blob = new Blob([payload], { type: 'application/json' });
        navigator.sendBeacon(`${API_BASE}/api/v1/public/track`, blob);
      } else {
        fetch(`${API_BASE}/api/v1/public/track`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: payload,
          keepalive: true,
        }).catch(() => {});
      }
    } catch { /* swallow */ }
  }, [pathname, search]);

  return null;
};

export default VisitTracker;
